<template>
  <div class="login register container-fluid">
    <div class="row eq-height">
      <div class="col-lg-7 login-left">
        <div class="row mt-20 side-pad login-header">
          <div class="col-6">
            <router-link to="/dashboard">
              <img
                class="login__image"
                src="@/assets/img/bettermynd-logo@2x.png"
                alt="BetterMynd"
              >
            </router-link>
          </div>
          <div class="col-6 text-right signup-link" />
        </div>

        <div class="login-content text-center">
          <div class="vertical-align-md">
            <terms v-if="target === 'terms'" @complete="flowTo('crisisquestion')" />
            <crisis-question v-else-if="target === 'crisisquestion'" @complete="flowTo('demographics')" />
            <demographics v-else-if="target === 'demographics'" @complete="flowTo('struggleAreas')" />
            <struggle-areas v-else-if="target === 'struggleAreas'" @complete="flowTo('counselorPreferences')" />
            <counselor-preferences v-else-if="target === 'counselorPreferences'" @back="handleBackButton()" @complete="finished()" />
          </div>
        </div>
      </div>
      <div class="d-none d-lg-block col-lg-5 register-right">
        <div class="vertical-align-md">
          <img
            class="forgot__image"
            src="@/assets/img/register-img@2x.png"
            alt="BetterMynd"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Terms from './flow/terms/terms.vue';
import Demographics from './flow/demographics/demographics.vue';
import CrisisQuestion from './flow/crisis-question/crisis-question.vue';
import StruggleAreas from './flow/counselor-preferences/struggle-areas.vue';
import CounselorPreferences from './flow/counselor-preferences/counselor-preferences.vue';

export default {
  name: 'Welcome',
  components: {
    Terms,
    Demographics,
    StruggleAreas,
    CounselorPreferences,
    CrisisQuestion
  },
  data() {
    return {
      target: 'terms',
    };
  },
  async mounted() {
    const user = this.$store.getters.currentUser;
    if (!user.needsWelcome) {
      this.goToDashboard();
    }

    if (this.userNeedsDemographics(user)) this.flowTo('terms');
    else if (this.userNeedsStruggleAreas(user)) this.flowTo('struggleAreas');
    else this.flowTo('counselorPreferences');
  },
  methods: {
    flowTo(target) {
      this.target = target;
    },
    goToDashboard() {
      this.$router.push({ name: this.$store.getters.currentUser.homeRouteName });
    },
    async finished() {
      this.$store.getters.currentUser.student_profile.completed_survey = true;
      this.goToDashboard()
    },
    userNeedsStruggleAreas(user) {
      return user.student_profile.struggle_areas.length === 0;
    },
    userNeedsDemographics(user) {
      return user.date_of_birth.length === 0;
    },
    handleBackButton() {
      this.flowTo('struggleAreas');
    },
  },
};
</script>

<style lang="scss" scoped>
.login-left,
.login-right,
.login-content,
.register-right {
  @media (min-width: $md-min) {
    height: calc(100vh - 180px);
    margin-top: 0;
    margin-bottom: 0;
    min-height: 800px;
    .login-content {
      margin-top: 80px;
    }
  }
}

.login-content {
  min-height: 730px;
}

.form__error {
  color: $red !important;
}

.register {
  p {
    color: rgba(white, 0.75);
  }

  .register-right {
    text-align: center;
    padding-left: 0;
    padding-right: 0;
    overflow: hidden;

    @media (min-width: $lg-min) {
      text-align: left;
      height: 100vh;
      background: rgb(42, 122, 161);
      background: linear-gradient(180deg, rgba(42, 122, 161, 1) 0%, rgba(40, 102, 159, 1) 100%);
    }

    img {
      width: 100%;
      height: auto;
      position: relative;
      z-index: 2;
      left: 0;

      @media (max-width: $md-max) {
        left: auto;
        right: auto;
        width: 75%;
        margin: 0 auto;
      }
    }
  }

  .form-check-label {
    color: $green;
  }

  a.green {
    color: $green;
  }

  ::v-deep .replacement-label {
    text-transform: uppercase;
    font-size: 10px;
    opacity: 0.75;
    letter-spacing: 0.1rem;
    margin-bottom: 5px;
  }
}
</style>
